/**
 * Register a plugin factory with the runtime when available.
 */
import type { PluginFactory } from "../lib/types";

export function registerPlugin(name: string, factory: PluginFactory) {
  const win = typeof window === "undefined" ? undefined : (window as any);
  if (win && typeof win.__PROSPIX_PLUGIN_REGISTER__ === "function") {
    win.__PROSPIX_PLUGIN_REGISTER__(name, factory);
  }
}
